import {AuthorizationServices} from "../services/authorization";
import {IAccount} from "../../Account/interfaces/account";
const isRole = (account: IAccount | null, role: string): [boolean] => {
  return [
    !!(account && AuthorizationServices.access(account, role))
  ];
}

export default isRole;
